import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'
import * as ACT from './actions'

const initialState = {
  dealSidebar: {
    isOpen: true
  },
  proposalSidebar: {
    isOpen: true
  },
  companySidebar: {
    isOpen: true
  },
  contactSidebar: {
    isOpen: true
  }
}

const sidebarReducer = createReducer(initialState, {
  [ACT.TOGGLE_SIDEBAR](state, action) {
    const { sidebarType, isOpen } = action.payload
    return update(state, {
      [sidebarType]: {
        isOpen: { $set: isOpen }
      }
    })
  }
})

export default sidebarReducer
